<div class="ngsild-year-range">
  <button
    type="button"
    class="ngsild-year-range__trigger"
    [class.ngsild-year-range__trigger--open]="isOpen"
    [class.ngsild-year-range__trigger--error]="hasError"
    [disabled]="disabled"
    (click)="toggleDropdown()"
  >
    <span class="ngsild-year-range__trigger-inner">
      <svg class="ngsild-year-range__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
      <span
        class="ngsild-year-range__value"
        [class.ngsild-year-range__value--placeholder]="!displayValue"
      >
        {{ displayValue || placeholder }}
      </span>
    </span>
    @if (displayValue && !disabled) {
      <span
        class="ngsild-year-range__clear"
        role="button"
        tabindex="0"
        aria-label="Clear year range"
        (click)="clear($event)"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path stroke="currentColor" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </span>
    }
  </button>

  @if (isOpen) {
    <div class="ngsild-year-range__panel" (click)="$event.stopPropagation()">
      <div class="ngsild-year-range__header">
        <span class="ngsild-year-range__decade">{{ getDecadeRange() }}</span>
        <div class="ngsild-year-range__nav">
          <button
            type="button"
            class="ngsild-year-range__nav-btn"
            aria-label="Previous decade"
            [disabled]="currentDecade - 20 < minYear"
            (click)="previousDecade()"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path stroke="currentColor" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            type="button"
            class="ngsild-year-range__nav-btn"
            aria-label="Next decade"
            [disabled]="currentDecade + 20 > maxYear"
            (click)="nextDecade()"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path stroke="currentColor" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
      <div class="ngsild-year-range__grid">
        @for (year of getYearsInDecade(); track year) {
          <button
            type="button"
            [ngClass]="yearCellClass(year)"
            [disabled]="year < minYear || year > maxYear"
            (click)="selectYear(year)"
            (mouseenter)="onYearHover(year)"
            (mouseleave)="onYearLeave()"
          >
            {{ year }}
          </button>
        }
      </div>
    </div>
  }
</div>
